import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';

import { InvitationService } from '@core/services/invitation';

@Component({
  selector: 'app-access-management-reports',
  standalone: true,
  imports: [CommonModule, ButtonModule, ProgressSpinnerModule, TooltipModule],
  templateUrl: './reports.html',
  styleUrl: './reports.scss'
})
export class AccessManagementReportsComponent {
  private readonly invitationService = inject(InvitationService);

  readonly summaryResource = this.invitationService.createInvitationsSummaryResource();

  refreshSummary(): void {
    this.summaryResource.reload();
  }

  formatDateTime(date: string | null | undefined): string {
    if (!date) return 'N/A';
    try {
      return new Date(date).toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
      });
    } catch {
      return 'Invalid date';
    }
  }
}
